import { Button, List, Row, Col } from 'antd';
import React, { useState } from 'react';
import {
  updateTrainerInfo,
  uploadTrainerImage,
} from '../../../services/trainerServices';
import InterestEdit from './InterestEdit';
import { beforeImageUpload } from '../../../utilities/imageUpload';
import DeleteWarningModalWithAction from '../../Common/DeleteWarningModalWithAction';

function InterestsCard({
  item,
  index,
  trainer,
  updateTrainerLocalData,
  updateTrainerData,
}) {
  const [isInterestModalOpen, setIsInterestModalOpen] = useState(false);
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode.',
  });

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  function toggleInterestEdit() {
    setIsInterestModalOpen((prev) => !prev);
  }

  async function onSubmit(values) {
    let interests = trainer.interests;
    interests[index] = values;

    setStatus({ type: 'LOADING', message: 'Loading for request!' });
    let trainerData = {
      ...trainer,
      interests,
    };

    await updateTrainerInfo(trainer.trainerId, trainerData)
      .then((response) => {
        updateTrainerLocalData(response.data.trainer);
        setStatus({ type: 'SUCCESS', message: 'Successful response' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  const initialValues = {
    title: item.title,
    imageLink: item.imageLink,
    description: item.description,
  };

  const onImageUpload = async (e) => {
    const interests = trainer.interests;
    const currentInterest = interests[index];
    const formData = new FormData();
    formData.append('name', `${currentInterest.title}`);
    formData.append('image', e.file);
    await uploadTrainerImage(formData, 'assets')
      .then((res) => {
        currentInterest.imageLink = res.data.imageUrl;
        interests[index] = currentInterest;
        const trainerData = { ...trainer, ...{ interests } };
        updateTrainerLocalData(trainerData);
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const onDelete = async () => {
    trainer.interests.splice(index, 1);
    const interests = trainer.interests;
    const trainerData = { ...trainer, ...{ interests } };
    await updateTrainerData(trainerData)
      .then((response) => {
        updateTrainerLocalData(response.data.trainer);
        setStatus({ type: 'SUCCESS', message: 'Successfully deleted field' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <div>
      <List.Item
        key={item.title}
        extra={
          <img width={272} height={180} alt="interest" src={item.imageLink} />
        }
      >
        <List.Item.Meta
          title={
            <Row justify="space-between">
              {item.title}
              <Col>
                <Button
                  onClick={toggleInterestEdit}
                  style={{ marginRight: '8px' }}
                >
                  Edit
                </Button>
                <Button onClick={() => setIsDeleteModalVisible(true)}>
                  Delete
                </Button>
              </Col>
            </Row>
          }
          description={<a href={item.imageLink}>{item.imageLink}</a>}
        />
        {item.description}
      </List.Item>
      <InterestEdit
        type="UPDATE"
        initialValues={initialValues}
        isOpen={isInterestModalOpen}
        status={status}
        toggle={toggleInterestEdit}
        onSubmit={onSubmit}
        onImageUpload={onImageUpload}
        beforeImageUpload={beforeImageUpload}
      />
      <DeleteWarningModalWithAction
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        action={onDelete}
      />
    </div>
  );
}

export default InterestsCard;
